module.exports = __webpack_public_path__ + "static/media/icn_ROI.d5585c82.svg";